import axios from './axios'
//注册
export async function register (params = {}) {
  return axios({
    url: `/h5/register`,
    method: 'post',
    data: params
  })
}
//登陆
export async function login (params = {}) {
  return axios({
    url: `/h5/login`,
    method: 'post',
    data: params
  })
}
//退出
export async function logout () {
  return axios({
    url: `/h5/logout`,
    method: 'post'
  })
}
//修改密码
export async function modifyPasswordByOld (params = {}) {
  return axios({
    url: `/h5/modifyPasswordByOld`,
    method: 'post',
    data: params
  })
}
//查询余额
export async function getBalance (params = {}) {
  return axios({
    url: `/h5/getBalance`,
    method: 'post',
    data: params
  })
}
//发送短信
export async function sendSms (params = {}) {
  return axios({
    url: `/h5/sendSms`,
    method: 'post',
    data: params
  })
}
//绑定手机
export async function bindPhone (params = {}) {
  return axios({
    url: `/h5/bindPhone`,
    method: 'post',
    data: params
  })
}
//解绑手机
export async function unBindPhone (params = {}) {
  return axios({
    url: `/h5/unBindPhone`,
    method: 'post',
    data: params
  })
}
//实名认证
export async function personCheck (params = {}) {
  return axios({
    url: `/h5/personCheck`,
    method: 'post',
    data: params
  })
}
//重置密码
export async function modifyPasswordByPhone (params = {}) {
  return axios({
    url: `/h5/modifyPasswordByPhone`,
    method: 'post',
    data: params
  })
}
//上报角色
export async function roleSync (params = {}) {
  return axios({
    url: `/h5/roleSync`,
    method: 'post',
    data: params
  })
}
//支付
export async function preOrder (params = {}) {
  return axios({
    url: `/h5/preOrder`,
    method: 'post',
    data: params
  })
}

//获取用户配置信息
export async function checkUser (params = {}) {
  return axios({
    url: `/h5/checkUser`,
    method: 'post',
    data: params
  })
}

//玩家自助充值  根据用户名查询游戏列表
export async function getPlayedGameList (params = {}) {
  return axios({
    url: `/open/order/getPlayedGameList`,
    method: 'post',
    data: params
  })
}

//玩家自助充值  充值
export async function qlOrder (params = {}) {
  return axios({
    url: `/open/order/qlOrder`,
    method: 'post',
    data: params
  })
}

//微信公众号支付
export async function jspay (params = {}) {
  return axios({
    url: `/open/pay/wxjspay`,
    method: 'post',
    data: params
  })
}

//查询攻略页面
export async function getContentById (id) {
  return axios({
    url: `/app/getContentById?contentId=${id}`,
    method: 'get'
  })
}

export async function wxAuth(params = {}){
  return axios({
    url: `/wx/authWx/${params.code}`,
    method: 'post',
    data: params
  })
}

export async function get(url){
  return axios({
    url: url,
    method: 'get'
  })
}

export async function request(options){
  return axios({
    url: options.url,
    method: options.method || 'post',
    data: options.data || {}
  })
}

export async function webTokenRequest(options){
  return axios({
    url: options.url,
    method: options.method || 'post',
    data: options.data || {},
    headers: {
      token : localStorage.getItem('web_token')
    }
  })
}
